import { Component, Input, input, output, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@Component({
	selector: "stages-switch",
	templateUrl: "./switch.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ReactiveFormsModule, FormsModule],
})
export class SwitchComponent {
	readonly id = input<string>();

	// TODO: Skipped for migration because:
	//  Your application code writes to the input. This prevents migration.
	@Input()
	value?: boolean;

	readonly valueChange = output<boolean>();

	valueChanged(): void {
		this.valueChange.emit(this.value ?? false);
	}
}
